module.exports = __webpack_public_path__ + "img/bit_recharge_icon.03aa64d1.svg";